__turbopack_context__.v({
  "crownIcon": "TopOrganizerLabel-module-scss-module___WzTvq__crownIcon",
  "label": "TopOrganizerLabel-module-scss-module___WzTvq__label",
});
